export const NO_WHITESPACE_AND_SYMBOLS = /^[\p{L}\p{N}]+$/u;
export const LOCAL_DATE_PATTERN = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;